// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__EeBKj","overlay":"Modal_overlay__b+zEz","modal":"Modal_modal__yEgVW","close":"Modal_close__nnot4","content":"Modal_content__yBmFf"};